export default "__VITE_ASSET__CDwvZtFC__"